import React from 'react';
import Text from './Text';
import { useFela } from 'react-fela';
import PropTypes from 'prop-types';

const headingStyles = ({ hidden }) => ({
  extend: [
    {
      condition: hidden,
      style: {
        width: '1px',
        height: '1px',
        position: 'absolute',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      },
    },
  ],
});

export default function Heading(props) {
  const { css } = useFela({
    hidden: props.hidden,
  });

  return (
    <Text
      as={props.as || 'h1'}
      fontWeight="600"
      color="primary"
      fontSize="pageHeading"
      className={css(headingStyles)}
      {...props}
    />
  );
}

Heading.propTypes = {
  hidden: PropTypes.bool,
  ...Text.propTypes,
};
